$(function() {

    var slider_arrow_left = "<div class='arrow arrow-left'>" +
        "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.42 28.61\"><defs><style>.cls-1{fill:none;stroke:rgba(255,255,255,.1);stroke-linecap:round;stroke-linejoin:round;stroke-width:1.3px;}</style></defs><title>Prev</title><g id=\"Слой_2\" data-name=\"Слой 2\"><g id=\"Layer_1\" data-name=\"Layer 1\"><polyline class=\"cls-1\" points=\"12.77 0.65 0.65 14.14 12.77 27.96\"/></g></g></svg>" +
        "</div>";

    var slider_arrow_right = "<div class='arrow arrow-right'>" +
        "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.42 28.61\"><defs><style>.cls-2{fill:none;stroke:rgba(255,255,255,.1);stroke-linecap:round;stroke-linejoin:round;stroke-width:1.3px;}</style></defs><title>Next</title><g id=\"Слой_2\" data-name=\"Слой 2\"><g id=\"Layer_1\" data-name=\"Layer 1\"><polyline class=\"cls-2\" points=\"0.65 0.65 12.77 14.14 0.65 27.96\"/></g></g></svg>" +
        "</div>";

    $('.work__slider').slick({
        arrows: true,
        dots: true,
        touchThreshold: 50,
        slidesToShow: 1,
        prevArrow: slider_arrow_left,
        nextArrow: slider_arrow_right,
        responsive: [
            {
                breakpoint: 575,
                settings: {
                    dots: false
                }
            }
        ]
    });

});